module.exports = __webpack_public_path__ + "assets/cover_4_old.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/cover_4_old.jpg
 ** module id = 209
 ** module chunks = 1
 **/